import { render } from "./Select2Locale.vue?vue&type=template&id=74bf1422"
import script from "./Select2Locale.vue?vue&type=script&lang=js"
export * from "./Select2Locale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__